const {KitModule, registerModule} = window;

class SearchField extends KitModule {
  constructor($element) {
    super($element);

    this.updateClearButton();

    this.$clearButton.addEventListener('click', this);
    this.$input.addEventListener('input', this);
  }

  onclick() {
    this.$input.value = '';
    this.$input.focus();
    this.updateClearButton();
  }

  oninput() {
    this.updateClearButton();
  }

  updateClearButton() {
    this.$clearButton.style.display = this.$input.value ? 'flex' : 'none';
  }
}

registerModule('SearchField', SearchField);
